import type { StaffTeamLoad } from "@lafayette/schemas";
import { useQuery } from "@tanstack/react-query";

import { useHomeRuntime } from "./runtime";

// The read behind the team load card: `GET /staff/team/load`. The answer holds staff and customer display names, so it stays in memory only
// while the card is on screen (`gcTime: 0`). It is read again every minute while the tab is visible and when the tab gets focus. A failed read
// is not retried by the library: the card shows the error and offers a retry.

export const teamLoadKey = ["home-team-load"] as const;
const TEAM_LOAD_REFRESH_MS = 60_000;

export function useTeamLoad() {
  const { teamLoad } = useHomeRuntime();
  return useQuery<StaffTeamLoad>({
    queryKey: teamLoadKey,
    queryFn: ({ signal }) => (teamLoad as NonNullable<typeof teamLoad>).teamLoad({ signal }),
    enabled: teamLoad !== undefined,
    gcTime: 0,
    staleTime: 30_000,
    retry: false,
    retryOnMount: false,
    refetchInterval: TEAM_LOAD_REFRESH_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
}
